(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
// noinspection JSUnresolvedReference -- Some variables are injected via PHP dynamically.

/**
 * AffiliateWP Multi-Currency admin
 *
 * @since  AFFWPN
 * @author Darvin da Silveira <ddasilveira@awesomeomotive.com>
 */

'use strict';

/* global jQuery */
/* eslint-disable no-console, no-undef, jsdoc/no-undefined-types */
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
affiliatewp.attach('multiCurrency',
/**
 * Multi-Currency Component.
 *
 * @since 1.0.0
 */
{
  /**
   * The data populated via PHP.
   *
   * @since 1.0.0
   * @type {Object} Populated dynamically via wp_add_inline_script().
   */
  data: {},
  /**
   * Specifies the selectors used in the code.
   *
   * @since 1.0.0
   * @type {Object}
   * @property {string} updateRatesButton      The selector for the button used to update exchange rates.
   * @property {string} licenseActivatorButton The selector for the button used to activate the license.
   * @property {string} select2UpdateMethod    The selector for the select element used to update method.
   * @property {string} currencySelect         The selector for the select element used for currency selection.
   * @property {string} statusMessageContainer The selector for the container that displays status messages.
   */
  selectors: {
    updateRatesButton: '#affwp-update-exchange-rates',
    licenseActivatorButton: '#multi_currency_api_key .affwp-settings-license-activator__button',
    select2UpdateMethod: '.affwp-multi-currency-update-method select',
    currencySelect: '.affwp-multi-currency-field-currency',
    statusMessageContainer: '#affwp-multi-currency-api-status'
  },
  /**
   * Initiate multi-currency functionalities.
   *
   * @since 1.0.0
   */
  init: function init() {
    var _this = this;
    document.addEventListener('DOMContentLoaded', function () {
      /*
       * Bind event to the update method dropdown, use jQuery to listen to the event since this is
       * triggered by select2, which depends on jQuery.
      	 */
      jQuery(affiliatewp.multiCurrency.selectors.select2UpdateMethod).on('change', _this.onUpdateMethodChanged);

      /*
       * Listen to events on the Update Rates clicks.
       * Will trigger an ajax request to fetch the currencies and update the repeater.
       */
      document.querySelector(affiliatewp.multiCurrency.selectors.updateRatesButton).addEventListener('click', _this.onUpdateRates);

      /*
       * Listen to the License Activator setting callback to decide if we can show the Update Rates button.
       */
      document.querySelector(affiliatewp.multiCurrency.selectors.licenseActivatorButton).addEventListener('affwpOnLicenseActivatorEnd', _this.onToggleApiActivation);
    });
  },
  /**
   * Toggle Update Rates visibility depending on the License Activator response.
   *
   * @since 1.0.0
   * @param {Event} event
   */
  onToggleApiActivation: function onToggleApiActivation(event) {
    var btnEl = document.querySelector(affiliatewp.multiCurrency.selectors.updateRatesButton);
    if (parseInt(event.detail.isActivated)) {
      btnEl.style.display = 'block';
      affiliatewp.multiCurrency.toggleManualEdit(false);
      affiliatewp.multiCurrency.onUpdateRates(null);
      return;
    }
    affiliatewp.multiCurrency.toggleManualEdit(true);
    affiliatewp.multiCurrency.data.exchangeRates = [];
    document.querySelector(affiliatewp.multiCurrency.selectors.statusMessageContainer).innerHTML = '';
    btnEl.style.display = 'none';
  },
  /**
   * Toggle Update Rates visibility depending on the Rates' Update Method selected.
   *
   * @since 1.0.0
   * @param {Event} event
   */
  onUpdateMethodChanged: function onUpdateMethodChanged(event) {
    var _document$querySelect, _affiliatewp, _affiliatewp2;
    var btnEl = document.querySelector(affiliatewp.multiCurrency.selectors.updateRatesButton);
    var isActivated = parseInt((_document$querySelect = document.querySelector(affiliatewp.multiCurrency.selectors.licenseActivatorButton)) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.dataset) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.isActivated) || 0;
    document.querySelector('.affwp-settings-license-activator__status').innerHTML = ((_affiliatewp = affiliatewp) === null || _affiliatewp === void 0 || (_affiliatewp = _affiliatewp.multiCurrency) === null || _affiliatewp === void 0 || (_affiliatewp = _affiliatewp.data) === null || _affiliatewp === void 0 ? void 0 : _affiliatewp.helpTexts[event.target.value]) || '';
    affiliatewp.multiCurrency.updateSelect2WithCompatibleOptions(((_affiliatewp2 = affiliatewp) === null || _affiliatewp2 === void 0 || (_affiliatewp2 = _affiliatewp2.multiCurrency) === null || _affiliatewp2 === void 0 || (_affiliatewp2 = _affiliatewp2.data) === null || _affiliatewp2 === void 0 ? void 0 : _affiliatewp2.unsupportedCurrencies[event.target.value]) || []);
    if ('manual' === event.target.value || !isActivated) {
      btnEl.style.display = 'none';
      affiliatewp.multiCurrency.toggleManualEdit(true);
      return;
    }
    affiliatewp.multiCurrency.toggleManualEdit(false);
    btnEl.style.display = 'block';
  },
  /**
   * Updates the Select2 dropdown with compatible options.
   *
   * The select2 for each row will be re-built everytime the method changes, ensuring the right
   * options are available to that method.
   *
   * @param {Array} unsupportedCurrencies
   * @since 1.0.0
   */
  updateSelect2WithCompatibleOptions: function updateSelect2WithCompatibleOptions(unsupportedCurrencies) {
    jQuery('.affwp-multi-currency-row select').each(function () {
      var _affiliatewp3;
      var $select = jQuery(this);
      var currentValue = $select.val();
      $select.empty();
      Object.entries(affiliatewp.multiCurrency.data.allCurrencies || {}).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          currencyCode = _ref2[0],
          currencyName = _ref2[1];
        var option = new Option(currencyName, currencyCode);
        if (unsupportedCurrencies.hasOwnProperty(currencyCode)) {
          option.disabled = true;
          option.text += " ".concat(affiliatewp.multiCurrency.data.i18n.unsupported);
        }
        $select.append(option);
      });
      if (unsupportedCurrencies.hasOwnProperty(currentValue)) {
        currentValue = Object.keys(affiliatewp.multiCurrency.data.allCurrencies)[0];
        $select.closest('.affwp-multi-currency-row').find('.affwp-multi-currency-currency').text(currentValue);
      }
      $select.val(currentValue);
      $select.select2('destroy');
      $select.select2(((_affiliatewp3 = affiliatewp) === null || _affiliatewp3 === void 0 || (_affiliatewp3 = _affiliatewp3.multiCurrencySettings) === null || _affiliatewp3 === void 0 || (_affiliatewp3 = _affiliatewp3.data) === null || _affiliatewp3 === void 0 ? void 0 : _affiliatewp3.currency_select2_settings) || {});
    });
  },
  /**
   * Toggles the manual edit mode for exchange rates in a multi-currency field.
   *
   * @param {boolean} manualEdit - Determines whether the manual edit mode should be enabled or disabled.
   */
  toggleManualEdit: function toggleManualEdit(manualEdit) {
    document.querySelectorAll('.affwp-multi-currency-exchange-rate').forEach(function (element) {
      element.style.display = manualEdit ? 'none' : 'initial';
    });
    document.querySelectorAll('.affwp-multi-currency-field-exchange-rate').forEach(function (element) {
      element.type = manualEdit ? 'number' : 'hidden';
    });
  },
  /**
   * Action to execute when the button to update rates is clicked.
   *
   * This function disables the button, gathers all the selected currency values,
   * sends an AJAX request to update the exchange rates, and updates the UI with the new rates.
   *
   * @since 1.0.0
   * @param {Event} event The event object associated with the click event.
   */
  onUpdateRates: function onUpdateRates(event) {
    if (event) {
      event.preventDefault();
    }
    var $button = jQuery(this);
    var $submitButton = jQuery('#submit');
    $button.addClass('affwp-is-loading');
    $submitButton.prop('disabled', true);
    var currencies = jQuery('.affwp-multi-currency-row .affwp-multi-currency-field-currency').map(function () {
      return jQuery(this).val();
    }).get();
    affiliatewp.multiCurrency.updateExchangeRates(currencies).done(function (result) {
      if (result.success) {
        affiliatewp.multiCurrency.updateExchangeRateFields(result.data.updated);
        affiliatewp.multiCurrency.data.exchangeRates = result.data.cached;
        document.querySelector(affiliatewp.multiCurrency.selectors.statusMessageContainer).innerHTML = result.data.statusMessage;
      } else {
        affiliatewp.multiCurrency.modal('', result.data, 'fa fa-info-circle', {
          confirm: {
            text: 'OK',
            btnClass: 'btn-confirm',
            keys: ['enter']
          }
        }, {
          closeIcon: false,
          type: 'red'
        });
      }
      $button.removeClass('affwp-is-loading');
      $submitButton.prop('disabled', false);
    }).fail(function () {
      $button.removeClass('affwp-is-loading');
      $submitButton.prop('disabled', false);
    });
  },
  /**
   * Launch a Modal
   *
   * Uses jQuery Confirm.
   *
   * @see https://craftpip.github.io/jquery-confirm/
   *
   * @since AFFWPN
   *
   * @param {string} title   Title.
   * @param {string} content Content.
   * @param {string} icon    Icon classes.
   * @param {Object} buttons Buttons.
   * @param {Object} args    Overriding Args.
   *
   * @return {Object} Modal Object.
   */
  modal: function modal(title, content, icon, buttons, args) {
    return jQuery.alert(jQuery.extend({
      backgroundDismiss: true,
      title: title,
      icon: icon,
      type: 'green',
      content: content,
      boxWidth: 400,
      useBootstrap: false,
      theme: 'modern,affiliatewp-education',
      closeIcon: true,
      draggable: false,
      dragWindowBorder: false,
      buttons: buttons
    }, args));
  },
  /**
   * Sends an AJAX request to update the exchange rates.
   *
   * This function sends the list of currencies to the server and retrieves the updated exchange rates.
   *
   * @since 1.0.0
   * @param {Array} currencies An array of currency codes to update.
   * @return {{getAllResponseHeaders: function(): *|null, abort: function(*): this, setRequestHeader: function(*, *): this, readyState: number, getResponseHeader: function(*): null|*, overrideMimeType: function(*): this, statusCode: function(*): this}|jQuery} The jQuery XMLHttpRequest (jqXHR) object.
   */
  updateExchangeRates: function updateExchangeRates(currencies) {
    return jQuery.ajax({
      url: ajaxurl,
      method: 'POST',
      dataType: 'json',
      data: {
        action: 'update_exchange_rates',
        nonce: affiliatewp.multiCurrency.data.nonce,
        currencies: currencies
      }
    });
  },
  /**
   * Updates the exchange rate fields in the UI with the new rates.
   *
   * This function iterates over the currency rows and sets the new exchange rate for each one.
   *
   * @since 1.0.0
   * @param {Object} exchangeRates An object where the keys are currency codes and the values are the new exchange rates.
   */
  updateExchangeRateFields: function updateExchangeRateFields(exchangeRates) {
    jQuery('.affwp-multi-currency-row:not(.affwp-multi-currency-row--header)').each(function (index) {
      var $row = jQuery(this);
      var $exchangeRateField = $row.find('.affwp-multi-currency-field-exchange-rate');
      if (exchangeRates[index]) {
        $exchangeRateField.val(exchangeRates[index].exchange_rate);
        $row.find('.affwp-multi-currency-exchange-rate').text(affiliatewp.multiCurrencySettings.formatExchangeRate(exchangeRates[index].exchange_rate));
      }
    });
  }
});

},{}]},{},[1]);
